export default class GeoConfig {
    constructor(geoConfigJson) {
        this.type = geoConfigJson.type;
        this.fixedValue = geoConfigJson.fixedValue;
        this.columnGuid = geoConfigJson.columnGuid;
        this.customFileGuid = geoConfigJson.customFileGuid;
        this.geometryType = geoConfigJson.geometryType;
        if (geoConfigJson.parent) {
            this.parent = new GeoConfig(geoConfigJson.parent);
        }
    }
    static getJsonInner(geoConfig) {
        const json = {
            type: geoConfig.type,
        };
        if (geoConfig.fixedValue) {
            json.fixedValue = geoConfig.fixedValue;
        }
        if (geoConfig.columnGuid) {
            json.columnGuid = geoConfig.columnGuid;
        }
        if (geoConfig.customFileGuid) {
            json.customFileGuid = geoConfig.customFileGuid;
        }
        if (geoConfig.geometryType) {
            json.geometryType = geoConfig.geometryType;
        }
        if (geoConfig.parent) {
            json.parent = GeoConfig.getJsonInner(geoConfig.parent);
        }
        return json;
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    getFixedValue() {
        return this.fixedValue;
    }
    setFixedValue(fixedValue) {
        return (this.fixedValue = fixedValue);
    }
    getColumnGuid() {
        return this.columnGuid;
    }
    setColumnGuid(columnGuid) {
        return (this.columnGuid = columnGuid);
    }
    getCustomFileGuid() {
        return this.customFileGuid;
    }
    setCustomFileGuid(customFileGuid) {
        return (this.customFileGuid = customFileGuid);
    }
    getParent() {
        return this.parent;
    }
    setParent(parent) {
        this.parent = parent;
    }
    getJson() {
        return GeoConfig.getJsonInner(this);
    }
    getCacheKey() {
        return JSON.stringify(this.getJson());
    }
    getGeometryType() {
        return this.geometryType;
    }
    setGeometryType(geometryType) {
        this.geometryType = geometryType;
    }
}
//# sourceMappingURL=geo-config.js.map